import { getKPIRequest } from "@/api/getKPIRequest.ts"
import type { KPI, KPIGroupRequest, KPIValue } from "@/types/kpiTypes.ts"

import type { RollingChartConfig } from "../types/rollingChartTypes.ts"

export const getRollingKPIData = async (config: RollingChartConfig): Promise<KPI[]> => {
  const kpiRequest = []
  if (config.primaryKPIs.at(0)) kpiRequest.push(config.primaryKPIs[0])
  if (config.primaryKPIs.at(1)) kpiRequest.push(config.primaryKPIs[1])
  if (config.secondaryKPI) kpiRequest.push(config.secondaryKPI)

  const request: KPIGroupRequest = {
    returnSize: config.totalDays + config.averageDays - 1,
    kpis: kpiRequest,
  }

  const kpis = await getKPIRequest(request)
  const filteredKpis: KPI[] = kpis.map((kpi) => ({
    ...kpi,
    values: kpi.values?.filter((v) => v.type == "Actual").toReversed(),
  }))
  const rollingKpis: KPI[] = filteredKpis.map((kpi) => ({
    ...kpi,
    values: [],
  }))

  for (let i = 0; i < config.totalDays; i++) {
    rollingKpis.forEach((kpi, index) => {
      const last = filteredKpis[index].values?.at(i + config.averageDays - 1)

      if (last != undefined) {
        const subset = filteredKpis[index].values?.slice(i, i + config.averageDays) || []

        const rollingValue: KPIValue = subset.reduce(
          (a, c) => ({ ...a, value: a.value + c.value / config.averageDays }),
          { ...last, value: 0 },
        )

        kpi.values?.push(rollingValue)
      }
    })
  }
  return rollingKpis
}
